// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbar__mZC_qa","toolbarRight":"toolbarRight__ha1hR5","languageSelect":"languageSelect__zzeZ1X"};